<template>
    <div class="h-full">
        <template v-if="invitationToken">
            <template v-if="invitation">
                <template v-if="invitation.organization_id">
                    <form-create-account :organization-id="invitation.organization.id" :creator-persona="creatorPersona" :invitation="invitation"></form-create-account>
                </template>
                <template v-else>
                    <form-create-organization v-if="currentStep === 2" :organization-name="organizationName" :creator-persona="creatorPersona" :creator-personas="creatorPersonas" :invitation="invitation"></form-create-organization>
                    <form-create-account v-else-if="currentStep === 3" :organization-id="invitation.organization_id" :organization-name="organizationName" :creator-persona="creatorPersona" :invitation="invitation"></form-create-account>
                </template>
            </template>
            <template v-else>
                <invitation-link-error></invitation-link-error>
            </template>
        </template>
        <template v-else>
            <form-select-organization-option v-if="currentStep === 1"></form-select-organization-option>
            <form-find-organization v-else-if="currentStep === 2 && hash === 'find'"></form-find-organization>
            <form-create-organization v-else-if="currentStep === 2 && hash === 'create'" :organization-name="organizationName" :creator-persona="creatorPersona" :creator-personas="creatorPersonas"></form-create-organization>
            <form-create-account v-else-if="currentStep === 3" :organization-id="organizationId" :organization-name="organizationName" :creator-persona="creatorPersona" :invitation="invitation"></form-create-account>
        </template>
    </div>
</template>

<script>
import FormSelectOrganizationOption from './partials/form-select-organization-option';
import FormCreateOrganization from './partials/form-create-organization.vue';
import FormFindOrganization from './partials/form-find-organization.vue';
import FormCreateAccount from './partials/form-create-account.vue';
import InvitationLinkError from './partials/invitation-link-error.vue';

export default {
    components: {
        'form-select-organization-option': FormSelectOrganizationOption,
        'form-find-organization': FormFindOrganization,
        'form-create-organization': FormCreateOrganization,
        'form-create-account': FormCreateAccount,
        'invitation-link-error': InvitationLinkError,
    },

    props: {
        creatorPersonas: {
            type: Object,
            required: true,
        },
        invitationToken: {
            type: String,
            required: false,
        },
        invitation: {
            type: Object,
            required: false,
        },
    },

    data() {
        return {
            hash: window.location.hash.substr(1),
            steps: 3,
            currentStep: this.getInitialCurrentStep(),
            organizationId: null,
            organizationName: null,
            creatorPersona: null,
        };
    },

    created() {
        window.addEventListener('popstate', () => {
            const hash = window.location.hash.substr(1);
            this.broadcastHashChange(hash);
        });

        Bus.$on('changeScreen', ({ hash, step, organizationId = null, organizationName = null, creatorPersona = null }) => {
            this.setHash(hash);
            this.setStep(step);
            this.setOrganizationData(organizationId, organizationName, creatorPersona);
        });
    },

    methods: {
        setHash(hash) {
            window.history.pushState(null, null, `#${hash}`);
            this.broadcastHashChange(hash);
        },

        broadcastHashChange(hash) {
            this.hash = hash;
        },

        getInitialCurrentStep() {
            if (this.invitationToken) {
                if (this.invitation) {
                    if (this.invitation.organization_id === null) {
                        return 2;
                    }
                }
            }

            const currentStep = ['find', 'create'].includes(window.location.hash.substr(1)) ? 2 : 1;
            return currentStep;
        },

        setStep(step) {
            this.currentStep = step;
        },

        setOrganizationData(organizationId, organizationName, creatorPersona) {
            if (!['find', 'create'].includes(this.hash)) {
                this.organizationId = this.organizationName = this.creatorPersona = null;
                return;
            }

            this.organizationId = (this.hash === 'find') ? organizationId : null;
            this.organizationName = (this.hash === 'create') ? organizationName : null;
            this.creatorPersona = (this.hash === 'create') ? creatorPersona : null;
        },
    },
};
</script>
